import { gql, useMutation } from "@apollo/client"
import { InjectedOptions } from "@oysterhr/core"
import { AddCartaIDsToEngagementsInput, AddCartaIDsToEngagementsPayload } from "@oysterhr/schema"

export const ADD_CARTA_IDS_TO_ENGAGEMENTS_MUTATION = gql`
  mutation AddCartaIdsToEngagements($cartaEngagementIds: [CartaEngagementId!]!) {
    addCartaIdsToEngagements(input: { cartaEngagementIds: $cartaEngagementIds }) {
      errors
    }
  }
`

type MutationPayload = { addCartaIdsToEngagements: AddCartaIDsToEngagementsPayload }

export const useAddCartaIDsToEngagements = (
  options?: InjectedOptions<MutationPayload, AddCartaIDsToEngagementsInput>,
) => {
  return useMutation(ADD_CARTA_IDS_TO_ENGAGEMENTS_MUTATION, options)
}
